import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './App.css';
import Blog from './components/Blog/Blog';
import ErrorPage from './components/ErrorPage/ErrorPage';
import Home from './components/Home/Home';
import Statistics from './components/Home/Statistics/Statistics';
import QuizzesStart from './components/QuizzesStart/QuizzesStart';
import Main from './layout/Main';
function App() {
  const router = createBrowserRouter([
    {
      path:'/',
      element: <Main></Main>,
      errorElement:<ErrorPage></ErrorPage>,
      children:[
        {
          path:'/',
          loader:()=>fetch('https://openapi.programming-hero.com/api/quiz'),
          element:<Home></Home>
        },
        {
          path:'/quizzes/:quizeId',
          loader:({params})=>fetch(`https://openapi.programming-hero.com/api/quiz/${params.quizeId}`),
          element:<QuizzesStart></QuizzesStart>
        },
        {
          path:'/statistics',
          loader: ()=> fetch('https://openapi.programming-hero.com/api/quiz'),
          element:<Statistics></Statistics>
        },
        {
          path:'/blogs', element:<Blog></Blog>
        }
      ]
    }
  ])
  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
